import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, ValidatorFn } from '@angular/forms';
import { SchemaService } from '../../services/schema.service';
import { ValidationService } from '../../services/validation.service';
import { BoulderComment } from '../../model/boulder-comment';
import { CommentService } from '../../services/comment.service';
import { GuestService } from '../../services/guest-service';
import { AuthService } from '../../services/auth.service';
import { GuestInfoComponent } from '../guest-info/guest-info.component';
import { IonicModule, LoadingController, ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MessageComponent } from '../message/message.component';
import { PipesModule } from 'src/pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, MessageComponent, ReactiveFormsModule, PipesModule, RouterModule],
  selector: 'app-boulder-comments',
  templateUrl: './boulder-comments.component.html',
  styleUrls: ['./boulder-comments.component.scss'],
})
export class BoulderCommentsComponent implements OnInit {
  @Input('boulderId')
  boulderId: string;

  @Input('comments')
  comments: BoulderComment[];
  comment = new FormControl('', this.validatorFnForProperty());
  formGroup: FormGroup;

  constructor(
    private loadingCtrl: LoadingController,
    private schemaService: SchemaService,
    private modalCtrl: ModalController,
    private commentService: CommentService,
    private guestService: GuestService,
    public authService: AuthService,
    private translateService: TranslateService,
    private validationService: ValidationService) {
    this.formGroup = new FormGroup({
      username: this.comment
    });
  }

  isValid(): boolean {
    return this.formGroup.valid;
  }

  ngOnInit() {
    this.loadComments();
  }

  async sendComment() {
    if (this.guestService.isGuest()) {
      GuestInfoComponent.showAsModal(this.modalCtrl);
      return;
    }
    const loader = await this.loadingCtrl.create({
      message: this.translateService.instant('shared.please-wait')
    });
    await loader.present();
    try {
      this.comments = null;
      await this.commentService.addComment(this.boulderId, this.comment.value);
      this.comment.setValue('');
    } finally {
      await this.loadComments();
      loader.dismiss();
    }
  }

  private validatorFnForProperty(): ValidatorFn[] {
    return this.validationService.getFormValidator(this.schemaService.boulderCommentSchema, 'comment');
  }

  private async loadComments() {
    this.comments = await firstValueFrom(this.commentService.getComments$(this.boulderId));
  }

  async deleteComment(id) {
    this.comments = null;
    await this.commentService.deleteComment(id);
    await this.loadComments();
  }
}
